<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item :label="$t('合同名称')" prop="contractName">
              <a-input v-model="model.contractName" :placeholder="$t('请输入合同名称')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('合同金额')" prop="contractAmount">
              <a-input-number v-model="model.contractAmount" :placeholder="$t('请输入合同金额')" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('甲方')" prop="partyA">
              <a-input v-model="model.partyA" :placeholder="$t('请输入甲方')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('乙方')" prop="partyB">
              <a-input v-model="model.partyB" :placeholder="$t('请输入乙方')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('备注说明')" prop="remark">
              <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('附件上传')" prop="contractAnnex">
              <!-- <a-upload name="file" :multiple="false" :fileList="fileList" :beforeUpload="beforeUpload" :remove="handleRemove" @change="handleChange">
                  <a-button>
                      <a-icon type="upload" />
                      选择附件
                  </a-button>
              </a-upload> -->
              <JUpload v-model="fileList" @change="uploadChange"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        url: {
          add: "/jeecg-engineering/engineering/contractDetail/add",
          edit: "/jeecg-engineering/engineering/contractDetail/edit",
          queryById: "/jeecg-engineering/engineering/contractDetail/queryById",
          list: "/jeecg-engineering/engineering/contractDetail/list",
          upload: "sys/common/upload",
        },
        fileList: [],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules () {
        return {
          contractName: [{ required: true, message: this.$t('请输入合同名称') },],
          contractAmount: [{ required: true, message: this.$t('请输入合同金额') },],
        }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      uploadChange(file){
        this.model.contractAnnex = file;
      },
      // handleChange(info){
      //   const { fileList } = this;
      //   const formData = new FormData();
      //   fileList.forEach(file => {
      //     formData.append('file', file);
      //     formData.append('biz', 'temp');
      //   });
      //   postAction(this.url.upload,formData).then(res=>{
      //     if(res.success){
      //       this.model.contractAnnex = res.message;
      //     }
      //   });
      // },
      // beforeUpload (file) {
      //   this.fileList = [file];
      //   this.model.contractAnnexName = this.fileList[0].name;
      //   return false;
      // },
      // handleRemove (file) {
      //   const index = this.fileList.indexOf(file);
      //   const newFileList = this.fileList.slice();
      //   newFileList.splice(index, 1);
      //   this.fileList = newFileList;
      // },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,type) {
        // this.model = Object.assign({}, record);
        let that = this;
        getAction(this.url.list,{installationId:record.id}).then(res=>{
          if(res.success){
            that.model = res.result.records[0] || {};
            that.model.installationId = record.id;
            if (that.model.contractAnnex == null) {
              that.fileList = []
            } else {
              // that.fileList = [
              //   {
              //     uid: '1',
              //     name: that.model.contractAnnex,
              //     status: 'done ',
              //     linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
              //     url: historyFileUrl + '/' + that.model.contractAnnex,
              //   },
              // ]
              that.fileList = [that.model.contractAnnex];
            }
          }
        });
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            if(this.model.id){
              httpurl = this.url.edit;
            }else{
              httpurl = this.url.add;
            }
            postAction(httpurl,that.model).then(res=>{
              if(res.success){
                that.$message.success(res.message);
                 that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            });
          }
        })
      },
    }
  }
</script>
<style>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
</style>